/* eslint-disable */
import axios, { AxiosResponse } from "axios";
import { API_URI, baseUriTranslate } from "../../uri";

export const getFormsEnData = async (): Promise<AxiosResponse> => {
  delete axios.defaults.headers.common["Authorization"];
  delete axios.defaults.headers.common["X-Jwt"];
  const url = "/resources/translation/form/en.json";
  return axios.get(baseUriTranslate + url);
};

export const getFormsFrData = async (): Promise<AxiosResponse> => {
  delete axios.defaults.headers.common["Authorization"];
  delete axios.defaults.headers.common["X-Jwt"];
  const url = "/resources/translation/form/fr.json";
  return axios.get(baseUriTranslate + url);
};

export const getFormsEsData = async (): Promise<AxiosResponse> => {
  delete axios.defaults.headers.common["Authorization"];
  delete axios.defaults.headers.common["X-Jwt"];
  const url = "/resources/translation/form/es.json";
  return axios.get(baseUriTranslate + url);
};

export const getFormsItData = async (): Promise<AxiosResponse> => {
  delete axios.defaults.headers.common["Authorization"];
  delete axios.defaults.headers.common["X-Jwt"];
  const url = "/resources/translation/form/it.json";
  return axios.get(baseUriTranslate + url);
};

export const getTranslationEnData = async (): Promise<AxiosResponse> => {
  delete axios.defaults.headers.common["Authorization"];
  delete axios.defaults.headers.common["X-Jwt"];
  const url = "/resources/translation/common/en.json";
  return axios.get(baseUriTranslate + url);
};

export const getTranslationFrData = async (): Promise<AxiosResponse> => {
  delete axios.defaults.headers.common["Authorization"];
  delete axios.defaults.headers.common["X-Jwt"];
  const url = "/resources/translation/common/fr.json";
  return axios.get(baseUriTranslate + url);
};

export const getTranslationEsData = async (): Promise<AxiosResponse> => {
  delete axios.defaults.headers.common["Authorization"];
  delete axios.defaults.headers.common["X-Jwt"];
  const url = "/resources/translation/common/es.json";
  return axios.get(baseUriTranslate + url);
};

export const getTranslationItData = async (): Promise<AxiosResponse> => {
  delete axios.defaults.headers.common["Authorization"];
  delete axios.defaults.headers.common["X-Jwt"];
  const url = "/resources/translation/common/it.json";
  return axios.get(baseUriTranslate + url);
};

export const getDistributorEnData = async (): Promise<AxiosResponse> => {
  delete axios.defaults.headers.common["Authorization"];
  delete axios.defaults.headers.common["X-Jwt"];
  const url = "/resources/translation/distributor/en.json";
  return axios.get(baseUriTranslate + url);
};

export const getDistributorFrData = async (): Promise<AxiosResponse> => {
  delete axios.defaults.headers.common["Authorization"];
  delete axios.defaults.headers.common["X-Jwt"];
  const url = "/resources/translation/distributor/fr.json";
  return axios.get(baseUriTranslate + url);
};

export const getDistributorEsData = async (): Promise<AxiosResponse> => {
  delete axios.defaults.headers.common["Authorization"];
  delete axios.defaults.headers.common["X-Jwt"];
  const url = "/resources/translation/distributor/es.json";
  return axios.get(baseUriTranslate + url);
};

export const getDistributorItData = async (): Promise<AxiosResponse> => {
  delete axios.defaults.headers.common["Authorization"];
  delete axios.defaults.headers.common["X-Jwt"];
  const url = "/resources/translation/distributor/it.json";
  return axios.get(baseUriTranslate + url);
};

export const getCustomTranslation = async (locale: string) => {
  const url = `/translations/${locale}`;
  return axios.get(API_URI + url);
};

export function sortAlphabetically(
  a: string,
  b: string,
  t: (key: string) => string
) {
  if (a && b) {
    return t(a).localeCompare(t(b));
  }
  return 0;
}

export const getCustomFrenchTranslation = () => getCustomTranslation("fr");
export const getCustomEnglishTranslation = () => getCustomTranslation("en");
export const getCustomSpanishTranslation = () => getCustomTranslation("es");
export const getCustomItalianTranslation = () => getCustomTranslation("it");
